window.addEventListener('message', function(event) {
    if (!event.data) {
        return;
    }
    try {
        var eventData = JSON.parse(event.data);
        if (eventData.name === 'pixlee:set:uploader:profile') {
            window._customerProvidedUserProfile = eventData.data;
        }
    } catch (_) {
        // ignore failed data parsing
    }
});

Pixlee.module('UploaderV3App', function(UploaderApp, App, Backbone, Marionette, $) {
    UploaderApp.on("start", function(options) {
        new UploaderApp.Show.Controller(options);

        var event = {
            name: 'pixlee:uploader:open',
            type: 'action',
            source: 'uploader',
            destination: 'parent',
            data: {}
        };

        window.top.postMessage(JSON.stringify(event), '*');
    });
});
